/* DRIP PREMIUM THEME v2 — JavaScript */
'use strict';

document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initGallery();
  initVariants();
  initQtyControls();
  initProductForm();
  initTabs();
  initFAQ();
  initScrollAnimations();
  updateCartCount();
});

/* ── MOBILE MENU ── */
function initMobileMenu() {
  const btn = document.getElementById('mob-menu-btn');
  const menu = document.getElementById('mob-menu');
  if (!btn || !menu) return;
  btn.addEventListener('click', () => {
    menu.classList.toggle('open');
    btn.setAttribute('aria-expanded', menu.classList.contains('open'));
  });
  document.addEventListener('click', (e) => {
    if (!menu.contains(e.target) && !btn.contains(e.target)) {
      menu.classList.remove('open');
    }
  });
}

/* ── GALLERY ── */
function initGallery() {
  const mainImg = document.getElementById('gallery-main-img');
  const thumbs = document.querySelectorAll('.thumb');
  if (!mainImg || !thumbs.length) return;
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src;
      mainImg.style.opacity = '0';
      setTimeout(() => {
        mainImg.src = src;
        mainImg.style.opacity = '1';
      }, 160);
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });
}

/* ── VARIANT SELECTION ── */
function initVariants() {
  const swatches = document.querySelectorAll('.swatch');
  const sizeBtns = document.querySelectorAll('.size-btn');

  swatches.forEach(s => {
    s.addEventListener('click', () => {
      const group = s.dataset.group;
      document.querySelectorAll(`.swatch[data-group="${group}"]`).forEach(x => x.classList.remove('active'));
      s.classList.add('active');
      const label = document.getElementById(`label-${group}`);
      if (label) label.textContent = s.dataset.value;
      updateVariantId();
    });
  });

  sizeBtns.forEach(b => {
    b.addEventListener('click', () => {
      const group = b.dataset.group;
      document.querySelectorAll(`.size-btn[data-group="${group}"]`).forEach(x => x.classList.remove('active'));
      b.classList.add('active');
      const label = document.getElementById(`label-${group}`);
      if (label) label.textContent = b.dataset.value;
      updateVariantId();
    });
  });
}

function updateVariantId() {
  // Variant matching logic — collects active option values and finds matching variant
  const variantData = window.DRIP_VARIANTS || [];
  if (!variantData.length) return;

  const selectedOptions = [];
  document.querySelectorAll('.swatch.active, .size-btn.active').forEach(el => {
    selectedOptions.push(el.dataset.value);
  });

  const match = variantData.find(v => {
    const opts = [v.option1, v.option2, v.option3].filter(Boolean);
    return selectedOptions.every(o => opts.includes(o));
  });

  if (match) {
    const input = document.getElementById('variant-id');
    if (input) input.value = match.id;
    const priceEl = document.getElementById('product-price');
    if (priceEl && match.price) {
      priceEl.textContent = '$' + (match.price / 100).toFixed(2);
    }
    const btnPrice = document.getElementById('btn-price');
    if (btnPrice && match.price) {
      btnPrice.textContent = '$' + (match.price / 100).toFixed(2);
    }
    const atcBtn = document.getElementById('atc-btn');
    if (atcBtn) {
      atcBtn.disabled = !match.available;
      atcBtn.textContent = match.available ? 'Add to Cart — $' + (match.price / 100).toFixed(2) : 'Sold Out';
    }
  }
}

/* ── QTY CONTROLS ── */
function initQtyControls() {
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.qty-input');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
      if (btn.dataset.action === 'plus') val = Math.min(99, val + 1);
      input.value = val;
    });
  });
}

/* ── PRODUCT FORM ── */
function initProductForm() {
  const form = document.getElementById('product-form');
  if (!form) return;
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const variantId = document.getElementById('variant-id')?.value;
    const qty = parseInt(document.querySelector('.qty-input')?.value) || 1;
    if (!variantId) return;
    addToCart(variantId, qty);
  });
}

function addToCart(variantId, qty = 1) {
  const btn = document.getElementById('atc-btn');
  const origText = btn?.innerHTML;
  if (btn) { btn.innerHTML = 'Adding...'; btn.disabled = true; }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty }),
  })
    .then(r => r.json())
    .then(data => {
      if (data.id) {
        showToast('✓ Added to your cart!');
        updateCartCount();
        if (btn) {
          btn.innerHTML = '✓ Added!';
          setTimeout(() => { btn.innerHTML = origText; btn.disabled = false; }, 2200);
        }
      } else {
        if (btn) { btn.innerHTML = origText; btn.disabled = false; }
      }
    })
    .catch(() => { if (btn) { btn.innerHTML = origText; btn.disabled = false; } });
}

/* ── CART COUNT ── */
function updateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    })
    .catch(() => {});
}

/* ── CART QTY UPDATE ── */
window.cartUpdateQty = function(key, qty) {
  if (qty < 0) qty = 0;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty }),
  }).then(() => window.location.reload());
};

/* ── TABS ── */
function initTabs() {
  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const tabId = btn.dataset.tab;
      const container = btn.closest('.product-tabs');
      if (!container) return;
      container.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
      container.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      const panel = container.querySelector(`[data-panel="${tabId}"]`);
      if (panel) panel.classList.add('active');
    });
  });
}

/* ── FAQ ── */
function initFAQ() {
  document.querySelectorAll('.faq-item').forEach(item => {
    const q = item.querySelector('.faq-q');
    if (!q) return;
    q.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });
}

/* ── SCROLL ANIMATIONS ── */
function initScrollAnimations() {
  const els = document.querySelectorAll('.spec-card, .review-card, .bundle-card, .trust-item, .value-card');
  if (!('IntersectionObserver' in window)) return;
  const obs = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  els.forEach((el, i) => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = `opacity .5s ease ${i * 0.06}s, transform .5s ease ${i * 0.06}s`;
    obs.observe(el);
  });
}

/* ── TOAST ── */
function showToast(msg) {
  let t = document.getElementById('drip-toast');
  if (!t) {
    t = document.createElement('div');
    t.id = 'drip-toast';
    t.className = 'toast';
    document.body.appendChild(t);
  }
  t.innerHTML = `<span class="toast-icon">✓</span> ${msg}`;
  t.classList.add('show');
  clearTimeout(t._timer);
  t._timer = setTimeout(() => t.classList.remove('show'), 3200);
}
